import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../components/global/Button';

const propTypes = {
  values: PropTypes.shape({
    email_address: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool.isRequired,
  onEditEmail: PropTypes.func.isRequired,
  onSendEmailVerification: PropTypes.func.isRequired,
  className: PropTypes.string,
};

const RegistrationEmailSent = ({
  values,
  loading,
  onEditEmail,
  onSendEmailVerification,
  className,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <p>
        We have sent a verification link to{' '}
        <span className="text-extra-bold">{values.email_address}</span> <br />{' '}
        Please check your inbox to proceed.
      </p>
      <div>
        <Button
          type="button"
          btnStyle="link"
          disabled={loading}
          loading={loading}
          onClick={() => onSendEmailVerification(values)}
          className="mb-2"
        >
          Re&ndash;send email verification
        </Button>
        <p className="text-sm mb-0">Not the right email?</p>
        <Button
          type="button"
          btnStyle="link"
          btnSize="sm"
          onClick={onEditEmail}
        >
          Edit your email
        </Button>
      </div>
    </div>
  );
};

RegistrationEmailSent.propTypes = propTypes;

export default RegistrationEmailSent;
